// extracted by mini-css-extract-plugin
export default {"Box":"VerifyAttestation-module__Box--Fwtj7","CopyToClipboardButton":"VerifyAttestation-module__CopyToClipboardButton--Hzr5n"};